<template>
  <section id="international-parcel-enquiry">
    <p>Please give a brief description of the reason for your enquiry</p>
    <EmailFormInput />
    <SubmitButton btnText="Submit Enquiry" />
  </section>
</template>

<script>
import EmailFormInput from '../../components/EmailFormInput'
import SubmitButton from '../../components/SubmitButton'

export default {
  components: {
    EmailFormInput,
    SubmitButton
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/InternationalParcelEnquiry.vue